/* @flow */

import type {NutshellState} from '../store';

export const getUIState = (state: NutshellState) => state.ui;
